// extracted by css-extract-rspack-plugin
export default {"loader":"QNtS5Y","image":"vjLnAg","loaded":"DVqN9V","fuck-safari":"nIICXo","fuckSafari":"nIICXo"};